import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=82f1161a&scoped=true&"
import script from "./Document.ts?vue&type=script&lang=ts&"
export * from "./Document.ts?vue&type=script&lang=ts&"
import style0 from "./Document.vue?vue&type=style&index=0&id=82f1161a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f1161a",
  null
  
)

export default component.exports